import React, { useContext, useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

import AppContext from '../../../context';
import { renamePortfolio } from '../../../../api';
import { ReactComponent as PencilEdit } from '../../../../assets/icons/pencil-edit-grey.svg';
import './rename_pf.component.css';

const RenamePfForm = (props) => {
  const context = useContext(AppContext);
  const { pf, show, setShow, setContext } = props;
  const pfId = pf.id;

  const [name, setName] = useState(pf.name);
  const [isRenaming, setIsRenaming] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState('');

  const submitForm = async (e) => {
    const _name = name.trim();
    if (!_name) {
      setError('Name required');
      return;
    }
    if (_name) {
      if (_name.length < 3) {
        setError('Name should be of atleast 3 characters.');
        return;
      }
      if (_name.length > 30) {
        setError('Name should be of max 30 characters.');
        return;
      }
    }
    setIsRenaming(true);
    try {
      const res = await renamePortfolio(pfId, _name);
      let pfs = [...context.portfolios];
      const pfIdx = context.portfolios.findIndex((_pf) => _pf.id == pfId);
      pfs[pfIdx] = { ...pfs[pfIdx], name: res.data.title };
      setContext({ portfolios: pfs });
      setIsRenaming(false);
      setShow(false);
    } catch (error) {
      setIsRenaming(false);
      setError('Something went wrong. Please try again');
    }
  };

  useEffect(() => {
    if (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
  }, [error]);

  return (
    <Modal
      show={show}
      centered
      onHide={() => setShow(false)}
      className={`rename_pf__modal ${props.className}`}
    >
      <Modal.Body>
        <PencilEdit />
        <h4>Rename Portfolio</h4>
        <div className="w-100 position-relative mb-3">
          <input
            type="text"
            placeholder="Portfolio name"
            required
            autoComplete="off"
            onChange={(e) => {
              if (error) setError(false);
              setName(e.target.value);
            }}
            value={name}
          />
          {isError && <p className="error text-danger mb-0">{error}</p>}
        </div>
        <div className="btns__cont">
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="confirm_btn"
            onClick={submitForm}
            disabled={isRenaming}
          >
            {isRenaming ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  color="#676767"
                  className="mr-2"
                />
                <span>Renaming Portfolio</span>
              </>
            ) : (
              <span>Rename Portfolio</span>
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RenamePfForm;
